import { render, staticRenderFns } from "./MatchScores.vue?vue&type=template&id=54a9491c&scoped=true"
import script from "./MatchScores.vue?vue&type=script&lang=js"
export * from "./MatchScores.vue?vue&type=script&lang=js"
import style0 from "./MatchScores.vue?vue&type=style&index=0&id=54a9491c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9491c",
  null
  
)

export default component.exports